import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import {
	useAIProfileData,
	useAISurfaceMetadata,
	useViewAIActions,
} from '@atlassian/ai-smart-button-api';
import { useProfileController } from '@atlassian/conversation-assistant-store';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { createHoverAnalyticsEvent } from '../../common/utils';

export const useSharedAISmartButtonLogic = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { setProfileData, setShowConvoStarters } = useViewAIActions();
	const surfaceMetadata = useAISurfaceMetadata();
	const profileDataFromStore = useAIProfileData();
	const profileData = useProfileController(profileDataFromStore);
	const hoverTimerRef = React.useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		if (profileData) {
			setProfileData(profileData);
		}
	}, [profileData, setProfileData]);

	const onAISmartButtonEnter = React.useCallback(() => {
		hoverTimerRef.current = setTimeout(() => {
			createHoverAnalyticsEvent(createAnalyticsEvent, surfaceMetadata);
		}, 1000);
	}, [createAnalyticsEvent, surfaceMetadata]);

	const onAISmartButtonLeave = React.useCallback(() => {
		if (hoverTimerRef.current) {
			clearTimeout(hoverTimerRef.current);
			hoverTimerRef.current = null;
		}
	}, []);

	return {
		createAnalyticsEvent,
		surfaceMetadata,
		setShowConvoStarters,
		onAISmartButtonEnter,
		onAISmartButtonLeave,
	};
};
